export default __webpack_public_path__ + "static/media/loder.969c1bc7.gif";